export const pageOptions = [
	{ value: '10', label: '10' },
	{ value: '20', label: '20' },
	{ value: '30', label: '30' },
];

// Error groups supported by Patient Dashboard filters
export const patientDashboardErrorGroups = [
	'System Error',
	'O2 Delivery Error',
	'Replace Columns',
	'Check Battery',
];
